
import Vue from "vue";
import sourcePreview from "components/SourcePreview.vue";
import {
  GetSourceInfo,
  GetPartnerSource,
  AddCourseScourse
} from "api/v1.design.courseware";
import {
  GetSchoolIdList,
  GetPartnerCourseType
} from "api/v1.partner.source";
import { Message } from "element-ui";
import PreparingCourseware from "components/PreparingCourseware.vue";

export default Vue.extend({
  name: "ToPartnerSource",
  components: {
    "source-preview": sourcePreview,
    PreparingCourseware
  },
  data() {
    return {
      files: [],
      label: "课件",
      pageSize: 8,
      pageIndex: 1,
      totalCount: 0,
      name: "source",
      list: <any>[],
      nodePathList: <any>[],
      tabPosition: "top",
      isShow_source: true,
      courseName: "22",
      newFolderId: "",
      dataCount: 1,
      sourceIds: <any>[],
      sourceId: "",
      checks: <any>[],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      disabled: false,
      checkStatus: false,
      checkArr: <any>[],
      dialogVisiblePreviewResources: false,
      activeName: "source",
      folderId: "",
      SchoolCourseId: "",
      IsSchoolCourseType: false,
      keyIndex: 0,
      SchoolCourseTypeList: <any>[],
      CreatedSchoolId: "",
      schoolList: <any>[],
      IsSource: false,
      defaultCover: require("assets/images/noCover.jpg") // 默认封面
    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    activityIds: {},
    importfolderId: {
      type: String,
      default: "0"
    },
    IsState: {
      type: Number,
      default: 0
    },
    setData: {
      type: Object,
      default: []
    }
  },
  created() {
    console.log("activityIds=" + this.activityIds);
    this.getSchoolIdList();
  },
  watch: {
    sourceIds() {
      this.$emit("update:setData", this.sourceIds);
    },
    checkData(val) {
      let checkLength = this.list.length;
      for (let i = 0; i < checkLength; i++) {
        if (this.list[i].checked) {
          if (this.list[i].checked == true) {
            this.list[i].chec1ked = false;
          }
        }
      }
    }
  },
  methods: {
    getSchoolIdList() {
      debugger;
      GetSchoolIdList().then(rst => {
        this.CreatedSchoolId = rst.SchoolList[0].CreatedSchoolId;
        this.$emit('update:CreatedSchoolId',this.CreatedSchoolId)
        this.schoolList = rst.SchoolList;
        if(this.schoolList.length>0){
          this.getPartnerCourseType(this.schoolList[0].CreatedSchoolId,0);
        }
      });
    },
    cance() {
      this.list = [];
      this.totalCount = 0;
      this.pageSize = 0;
      this.courseName = "";
      this.nodePathList = [];
      this.dataCount = 0;
    },
    onAllChangeHandler() {
      this.IsSource = true;
      this.folderId = "0";
      this.SchoolCourseId = "";
      this.getPartnerSource(1);
      this.cance();
      this.IsSchoolCourseType = false;
    },
    getPartnerCourseType(SchoolId: any, index: any) {
      debugger;
      this.IsSource = false;
      this.CreatedSchoolId = SchoolId;
      this.IsSchoolCourseType = true;
      this.keyIndex = index;
      GetPartnerCourseType(SchoolId).then(rst => {
        this.SchoolCourseTypeList = rst.list;
      });
    },
    GetSchool(event: any, index: number) {
      this.IsSource = true;
      this.folderId = "0";
      this.SchoolCourseId = event;
      // this.CreatedSchoolId=event;
      this.getPartnerSource(1);
      this.cance();
      this.IsSchoolCourseType = false;
    },

    ///关闭弹窗
    dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    ///获取合作伙伴资源
    getPartnerSource(page: any) {
      debugger;
      this.$nextTick(() => {
        GetPartnerSource(
          this.CreatedSchoolId,
          this.folderId,
          page,
          this.SchoolCourseId
        ).then(rst => {
          this.list = rst.list;
          this.totalCount = rst.pagination.totalCount;
          this.pageSize = rst.pagination.pageSize;
          this.courseName = rst.courseName;
          this.nodePathList = rst.nodePathList;
          this.dataCount = rst.dataCount;
          console.log(this.list);
        });
      });
    },
    ///打开文件夹
    clickFolderHander(newFolderId: any) {
      this.folderId = newFolderId;
      let pageIndex = this.list.pageIndex;
      this.getPartnerSource(pageIndex);
    },
    ///预览课件
    previewImage(Id: string, url: string, type: string) {
      if (type == ".zip" || type == ".rar" || type == "7z") {
        this.$message("压缩包不支持预览");
      } else {
        if (type != "") {
          this.sourceId = Id;
          this.dialogVisiblePreviewResources = true;
        }
        GetSourceInfo(Id).then(rst => {
          console.log(rst);
          if (rst.status == -1) {
            Message.warning("文件转换失败不能预览");
          } else if (rst.status == -2) {
            Message.warning("文件正在转换请稍后预览");
          } else if (rst.status == 1) {
            this.sourceUrl = {
              id: Id,
              url: rst.docPriviewUrl,
              type: type,
              docName: rst.docName,
              docType: rst.docType
            };
          }
        });
      }
    },
    ///分页
    onPageChangeHandler(page: number) {
      this.getPartnerSource(page);
    },
    ///选择资源
    handleSelectionChange(source: any) {
      let idx = this.sourceIds.indexOf(source.Id);
      let checked = source.checked;
      if (idx >= 0 && !checked) {
        this.sourceIds.splice(idx, 1);
      } else if (idx < 0 && checked) {
        this.sourceIds.push(source.Id);
      }
    },
    ///导入课件
    importSource() {
      debugger
      console.log(this.CreatedSchoolId+"asedasdadasdasdas");
      if (this.sourceIds.length == 0) {
        this.$message.warning("请选择课件！");
      } else {
        AddCourseScourse(
          this.sourceIds,
          this.courseId,
          this.importfolderId,
          this.CreatedSchoolId
        ).then(rst => {
          if (rst.code > 0) {
            this.$emit("update:IsState", Math.random());
            this.$message.success(rst.msg);
          } else {
            this.$message({
              type: "warning",
              message: rst.msg
            });
          }

          let checkLength = this.list.length;
          for (let i = 0; i < checkLength; i++) {
            if (this.list[i].checked) {
              if (this.list[i].checked == true) {
                this.list[i].checked = false;
              }
            }
          }
          this.sourceIds = [];
          this.$emit("closeDialog", true);
        });
      }
      this.disabled = false;
      this.checkStatus = true;
    }
  }
});
